import axios from "axios";
import {getApiLink} from "../functions/getApiLink";
import getCookies from "../functions/getCookie";
import setCookie from "../functions/setCookie";
import {setAccessToken, setUser} from "../storage/toolkit";
import {getBearer} from "../functions/getBearer";
import { access_token, refresh_token } from "./CookieKeys";
import { isPublicPath } from "../functions/publicRoutes";

export const GetAccessToken = (dispatch: any, callbackFunction?: any) => {

    // Nothing to refresh on a screen that works without a session, and every
    // exit below leaves the page - which would take the reset-password screen
    // away from the very people who came to it because they cannot sign in.
    if(isPublicPath()) return;

    const cookies = getCookies(refresh_token);

    getBearer("post")
    axios.post(getApiLink("/api/auth/refresh/"), {
        "refresh_token": cookies
    }).then(({data}) => {

        setCookie(access_token, data.access_token)
        dispatch(setUser(data.user))
        dispatch(setAccessToken(data.access_token))
        window.location.href = "/"

        callbackFunction()

    }).catch(er => {
        console.log("er refresh",er)

        if(isPublicPath()) return;

        window.location.href = "/login"
    })

}